import { useEffect } from 'react'
import { useBild } from '../lib/bild'
import Bildfehler from './Bildfehler'

/**
 * Ein Bild groß ansehen, ohne die Seite zu verlassen.
 *
 * Über Ausstattung entscheidet man an Einzelheiten — ob der Kasten dort ein
 * Sandkasten ist oder ein Beet, ob das Gestell hinten eine Schaukel ist. Auf
 * einem Vorschaubild von 120 Pixeln ist das nicht zu sehen.
 *
 * Gezeigt wird das **Original**, nicht die kleine Variante: Wer hinsieht,
 * will mehr sehen, nicht dasselbe größer gerechnet.
 */
export default function Bildlupe({
  pfad,
  schliessen,
}: {
  pfad: string
  schliessen: () => void
}) {
  const bild = useBild(pfad)

  useEffect(() => {
    function beiTaste(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        // Sonst hörte der Stapel darunter mit und schlösse seinen Dialog.
        e.stopPropagation()
        schliessen()
      }
    }
    // In der Erfassungsphase: Der Stapel hängt am selben Fenster und würde
    // sein eigenes Escape zuerst verarbeiten.
    window.addEventListener('keydown', beiTaste, true)
    return () => window.removeEventListener('keydown', beiTaste, true)
  }, [schliessen])

  return (
    <div
      className="lupe"
      role="dialog"
      aria-modal="true"
      aria-label="Bild groß ansehen"
      onClick={schliessen}
    >
      {/* Ein Klick ins Bild schließt nicht — man zoomt oder zieht daran. */}
      <div className="lupe-inhalt" onClick={(e) => e.stopPropagation()}>
        {bild.art === 'laedt' && <p className="gedaempft">Bild lädt …</p>}
        {bild.art === 'fehler' && <Bildfehler zustand={bild} />}
        {bild.art === 'da' && <img src={bild.adresse} alt="Eingereichtes Bild" />}
        <div className="lupe-fuss">
          <span className="leise zahl">{pfad}</span>
          <button className="knopf knopf-still" type="button" onClick={schliessen}>
            Schließen <kbd>Esc</kbd>
          </button>
        </div>
      </div>
    </div>
  )
}
